import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withInMemoryScrolling,
  withComponentInputBinding,
  withRouterConfig,
  withNavigationErrorHandler,
  withPreloading,
} from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  ActiveSectionPreloadingStrategy,
  applicationConfigProviders,
} from '@padspin/web';
import {
  MissingChunkErrorHandler,
  reloadOnMissingRouteChunk,
} from '@padspin/ui-header';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withPreloading(ActiveSectionPreloadingStrategy),
      withNavigationErrorHandler(reloadOnMissingRouteChunk),
    ),
    { provide: ErrorHandler, useClass: MissingChunkErrorHandler },
    ...applicationConfigProviders,
  ],
};
